import deepMerge from 'deepmerge';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mergeArrays(base, override, helpers) {
    const { cloneUnlessOtherwiseSpecified , isMergeableObject  } = helpers;
    // clone the target array
    const final = [
        ...base
    ];
    override.forEach((overrideItem, index)=>{
        const baseItem = base[index];
        if (isMergeableObject(overrideItem)) {
            // if we encounter a "mergeable" object, merge it with the base item
            /* eslint-disable @typescript-eslint/no-use-before-define */ final[index] = mergeTwo(baseItem, overrideItem);
        } else {
            // otherwise just replace whatever was in the base array with the override
            final[index] = cloneUnlessOtherwiseSpecified(overrideItem, helpers);
        }
    });
    return final;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function mergeTwo(base, override) {
    return deepMerge(base, override, {
        arrayMerge: mergeArrays
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
function merge(propsObjects) {
    return deepMerge.all(propsObjects, {
        arrayMerge: mergeArrays
    });
}

export { merge };
